import { render, staticRenderFns } from "./LabelSelectSimple.vue?vue&type=template&id=b6b8d8b8"
import script from "./LabelSelectSimple.vue?vue&type=script&lang=js"
export * from "./LabelSelectSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports